import type { ChartCheckHandler } from './checkIfFiltered.types';
import { checkIfSelected } from '../check-if-selected/checkIfSelected';

export const checkIfFiltered: ChartCheckHandler = (
  item,
  type,
  selected,
  props,
): true | false | undefined => {
  if (selected === undefined) return undefined;
  const check = props?.checkIfSelected ?? checkIfSelected;
  const is_selected = check(item, type, selected, props);
  return is_selected === undefined ? undefined : !is_selected;
};
